/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'student-check': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M922.298 885.341l-57.344-52.596a52.503 52.503 0 00-14.894-43.706l-52.317-52.364a54.69 54.69 0 00-5.726-4.98 391.168 391.168 0 0086.435-245.9 392.704 392.704 0 10-392.657 392.657c86.574 0 166.54-27.927 231.424-75.403a62.096 62.096 0 006.377 7.773l52.363 52.363a52.27 52.27 0 0057.112 11.45l53.9 49.385a26.159 26.159 0 1035.374-38.679zM485.795 826.09a340.061 340.061 0 01-240.687-99.747 338.292 338.292 0 01-99.607-240.64 338.758 338.758 0 0199.747-240.687 338.292 338.292 0 01240.64-99.607 340.154 340.154 0 01240.687 99.747 338.385 338.385 0 0199.607 240.64 340.108 340.108 0 01-99.747 240.686 338.339 338.339 0 01-240.64 99.608z" _fill="#2c2c2c"/><path pid="1" d="M197.818 485.795a287.977 287.977 0 10575.907 0 287.977 287.977 0 00-575.907 0z" _fill="#2c2c2c"/>'
  }
})
